<template>
    <div class="ah-page accounting-business-tax-page">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>傳票編輯</h1>
                    </div>
                    <div class="actions">
                        <el-button type="dark" @click="openInNewTab('https://tax.nat.gov.tw/alltax-download.html?id=2')">前往申報網站 <i class="el-icon-link"></i></el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel">
                <div class="panel-header small gray">
                    <div class="panel-title">交易內容</div>
                </div>
                <div class="panel-body">
                    <div>
                        <div>類別{{ detail.typeName }}</div>
                        <div>日期{{ detail.createDate | dateFormater("YYYY-MM-dd") }}</div>
                        <div>單號{{ detail.displayNumber }}</div>
                        <div>交易事項{{ detail.name }}</div>
                        <div>憑證{{ detail.credentialsName }}</div>
                        <div>付款方式{{ detail.payType === 1 ? "零用現金" : "轉帳" }}</div>
                        <div>銀行帳戶{{ detail.bankName }}</div>
                        <div>狀態{{ detail.payStatus === 1 ? "已入帳" : "未入帳" }}</div>
                        <div>出/入帳日期{{ detail.payDate | dateFormater("YYYY-MM-dd") }}</div>
                    </div>
                    <div>金額{{ detail.amount }}</div>
                    <!-- 有折讓或退款 -->
                    <div v-if="detail.dicountDate">
                        <div>折讓/退款{{ detail.dicount }}</div>
                        <div>日期{{ detail.dicountDate | dateFormater("YYYY-MM-dd") }}</div>
                    </div>
                    <div>
                        <div>憑證金額{{ detail.credentials_Amount }}</div>
                        <div v-if="voucherType === 1 || voucherType === 3">進項稅額{{ detail.tax_Amount }}</div>
                        <div v-else>銷項稅額{{ detail.tax_Amount }}</div>
                    </div>
                    <!-- 有代扣稅款 -->
                    <div v-if="detail.withholdingTax || detail.withholdingTax_Health2 || detail.withholdingTax_Labor || detail.withholdingTax_Health">
                        <div>代扣稅款{{ detail.withholdingTax }}</div>
                        <div>代扣二代健保{{ detail.withholdingTax_Health2 }}</div>
                        <div>代扣勞保{{ detail.withholdingTax_Labor }}</div>
                        <div>代扣健保{{ detail.withholdingTax_Health }}</div>
                    </div>
                    傳票狀態
                    <el-radio-group size="small" v-model="detail.vocherStatus" @change="changeVocherStatus">
                        <el-radio-button :label="0">待辦</el-radio-button>
                        <el-radio-button :label="1">完成</el-radio-button>
                    </el-radio-group>
                </div>
            </div>
            <div style="text-align: right; margin: 5px 0 30px 0">
                <el-button v-show="!hasUnsent" type="primary" class="primary-action" @click="addVoucher">新增傳票</el-button>
            </div>
            <div class="ah-panel" v-for="(item, index) in vouchers" :key="index">
                <div class="panel-header small gray">
                    <div class="panel-title">傳票</div>
                    <div class="panel-action">
                        <div v-if="item.sno">
                            <el-button class="submit-btn" size="small" @click="printVoucher(item)">列印</el-button>
                            <el-button class="submit-btn" size="small" @click="editIndex = index">編輯</el-button>
                        </div>
                    </div>
                </div>
                <div class="panel-body">
                    <div class="voucher-sheet">
                        <!-- 傳票檢視 -->
                        <div v-if="item.sno && editIndex !== index">
                            <el-row :gutter="40">
                                <el-col :sm="12">
                                    <table class="ah-basic-data-table" cellspacing="0" cellpadding="0">
                                        <tr>
                                            <th>傳票日期：</th>
                                            <td>
                                                {{ item.dat | dateFormater("YYYY-MM-dd") }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>傳票號碼：</th>
                                            <td>{{ item.vono }}</td>
                                        </tr>
                                        <tr>
                                            <th>製表人：</th>
                                            <td>{{ item.crT_USR }}</td>
                                        </tr>
                                    </table>
                                </el-col>
                                <el-col :sm="12">
                                    <table class="ah-basic-data-table" cellspacing="0" cellpadding="0">
                                        <tr>
                                            <th>公司：</th>
                                            <td>
                                                {{ $store.getters["account/company"] }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>幣別：</th>
                                            <td>
                                                {{ getCurrencyName(item.cny) }}
                                            </td>
                                        </tr>
                                    </table>
                                </el-col>
                            </el-row>
                            <table class="voucher-table" cellspacing="0" cellpadding="0">
                                <tr>
                                    <td class="setting">會計科目</td>
                                    <td class="name">摘要</td>
                                    <td class="crd-amt">借方金額</td>
                                    <td class="deb-amt">貸方金額</td>
                                </tr>
                                <tr v-for="(element, elementIndex) in item.accountItems" :key="elementIndex">
                                    <td class="setting">
                                        <span>{{ element.accnonam }}</span>
                                    </td>
                                    <td class="name">
                                        <span>{{ element.content }}</span>
                                    </td>
                                    <td class="crd-amt">
                                        <span v-if="element.crD_NTD != 0">
                                            <Money :v="element.crD_NTD" />
                                        </span>
                                    </td>
                                    <td class="deb-amt">
                                        <span v-if="element.deB_NTD != 0">
                                            <Money :v="element.deB_NTD" />
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td class="sum-label">合計</td>
                                    <td class="crd-amt">
                                        <Money :v="getVoucherCRDAmount(index)" />
                                    </td>
                                    <td class="deb-amt">
                                        <Money :v="getVoucherDEBAmount(index)" />
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <!-- 傳票編輯 -->
                        <div v-else>
                            <div v-if="item.cnl">作廢</div>
                            <!-- 已送出 -->
                            <span v-if="item.sno && editIndex !== index">{{ $store.getters["account/company"] }}</span>
                            傳票日期
                            <!-- 已送出 -->
                            <span v-if="item.sno && editIndex !== index">{{ item.dat | dateFormater("YYYY-MM-dd") }}</span>
                            <el-date-picker v-else v-model="item.dat" value-format="timestamp" type="date" placeholder="選擇日期"> </el-date-picker>
                            <!-- 已送出 -->
                            <span v-if="item.sno && editIndex !== index">傳票號碼 {{ item.vono }}</span>
                            幣別：
                            <!-- 已送出 -->
                            <span v-if="item.sno && editIndex !== index">{{ getCurrencyName(item.cny) }}</span>
                            <el-select v-else v-model="item.cny" prop="cny" slot="append" style="width: 100px">
                                <el-option :label="item.cnynam" :value="item.cny" v-for="item in currencyList" :key="item.sno"></el-option>
                            </el-select>
                            <table class="voucher-table" cellspacing="0" cellpadding="0">
                                <tr>
                                    <td class="setting">會計科目</td>
                                    <td class="name">摘要</td>
                                    <td class="crd-amt">借方金額</td>
                                    <td class="deb-amt">貸方金額</td>
                                    <td></td>
                                </tr>
                                <tr v-for="(element, elementIndex) in item.accountItems" :key="elementIndex">
                                    <td class="setting">
                                        <el-autocomplete
                                            :value="getAccountingItem(element)"
                                            :fetch-suggestions="querySearch"
                                            placeholder="請輸入內容"
                                            @select="item => handleSelect(item, index, elementIndex)"
                                        >
                                            <template slot-scope="{ item }">
                                                <span>{{ item.accno }} {{ item.accnam }}</span>
                                            </template></el-autocomplete
                                        >
                                    </td>
                                    <td class="name">
                                        <el-input v-model="element.content" placeholder="請輸入"></el-input>
                                    </td>
                                    <td class="crd-amt">
                                        <el-input v-model.number="element.crD_NTD" placeholder="請輸入"></el-input>
                                    </td>
                                    <td class="deb-amt">
                                        <el-input v-model.number="element.deB_NTD" placeholder="請輸入"></el-input>
                                    </td>
                                    <td>
                                        <span v-show="editIndex === index" @click="deleteSubItem(item.accountItems, elementIndex)" @keydown="() => {}">X</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="5">
                                        <el-button v-show="editIndex === index" type="primary" class="submit-btn" round @click="addVoucherAccount(index)">+</el-button>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">合計</td>
                                    <td>{{ getVoucherCRDAmount(index) }}</td>
                                    <td>{{ getVoucherDEBAmount(index) }}</td>
                                    <td></td>
                                </tr>
                            </table>
                        </div>
                        <!-- 未送出 -->
                        <div class="actions">
                            <div v-if="!item.sno">
                                <el-button type="" @click="deleteVoucher(index)">取消</el-button>
                                <el-button type="primary" class="primary-action" @click="submitForm(index)">送出</el-button>
                            </div>
                            <dib v-if="item.sno != null && editIndex === index">
                                <el-button type="" @click="voidVoucher(item.sno)">作廢</el-button>
                                <el-button type="" @click="cancelEdit()">取消</el-button>
                                <el-button type="primary" class="primary-action" @click="submitForm(index)">儲存</el-button>
                            </dib>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'AccountingSummaryEditPage',
    data() {
        return {
            editIndex: null,
            voucherType: null,
            detail: {},
            vouchers: [],
            currencyList: [],
            accountingItems: [],
        };
    },
    computed: {
        hasUnsent() {
            // 傳票有還沒送出的
            if (this.vouchers.length > 0) {
                return this.vouchers.some((voucher) => !voucher.sno);
            }

            return false;
        },
    },
    created() {
        console.log(this.$route.params.sno);
        this.fetchVoucherData(this.$route.params.sno);
        this.fetchCurrencyList();
        this.fetchAccountingOptions();
        this.fetchVoucherLists();

        this.detail = this.$route.params.datas;
        this.voucherType = this.$route.params.voucherType;
    },
    methods: {
        fetchVoucherData(sno) {
            this.$api({
                url: '/AccountingSummaryPage/QueryAccountingSummary',
                params: {
                    sno,
                },
                method: 'GET',
            }).then((resp) => {
                console.log(resp);
            });
        },
        // 取得會計科目列表
        fetchAccountingOptions() {
            this.$api({
                url: '/AccountingSettingPage/GetAccountingSettings',
                method: 'GET',
            }).then((resp) => {
                // this.accountingItems = resp.data;
                // let that = this;
                Object.keys(resp.data).forEach((key) => {
                    resp.data[key].forEach((item) => {
                        this.accountingItems.push(item);
                    });
                });
            });
        },
        // 取得幣別列表
        fetchCurrencyList() {
            this.$api({
                url: '/BankAccountSettingPage/GetCurrencyOptions',
                method: 'GET',
            }).then((resp) => {
                this.currencyList = resp.data.options;
            });
        },
        // 取得傳票列表
        fetchVoucherLists() {
            this.$api({
                url: `/AccountingSummaryPage/GetVouchers?UNT_NBR=${this.$route.params.UNT_NBR}`,
                method: 'GET',
            })
                // 取得成功
                .then((resp) => {
                    // 更新資料
                    this.vouchers = resp.data.items;
                });
        },
        goBack() {
            this.$router.push({ name: 'accounting-summary' });
        },
        querySearch(queryString, cb) {
            const { accountingItems } = this;
            const results = queryString
                ? accountingItems.filter(
                    (accountingItem) => accountingItem.accnam.toLowerCase().indexOf(queryString.toLowerCase()) !== -1 || accountingItem.accno.toLowerCase().indexOf(queryString.toLowerCase()) !== -1,
                )
                : accountingItems;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        handleSelect(item, index, elementIndex) {
            this.vouchers[index].accountItems[elementIndex].accno = item.accno;
            this.vouchers[index].accountItems[elementIndex].accnonam = item.accnam;
        },

        printVoucher(item) {
            console.log('123', item);
            this.$router.push({
                name: 'accounting-summary-print',
                params: {
                    data: item,
                },
            });
        },
        voidVoucher(sno) {
            this.$api({
                url: '/AccountingSummaryPage/VoidVoucher',
                method: 'post',
                data: {
                    sno,
                },
            }).then(() => {
                this.fetchVoucherLists();
                this.editIndex = null;
            });
        },
        submitForm(index) {
            this.$api({
                url: '/AccountingSummaryPage/UpsertVouchers',
                method: 'post',
                data: this.vouchers[index],
            }).then(() => {
                this.fetchVoucherLists();
                this.editIndex = null;
            });
        },
        changeVocherStatus() {
            // 資料送出
            this.$api({
                url: '/AccountingSummaryPage/UpdateAccountStatus',
                method: 'post',
                data: {
                    sno: this.detail.sno,
                    voucherType: this.voucherType,
                    unt: null,
                    status: !!this.detail.vocherStatus,
                },
            }).then(() => {
                this.$message({
                    showClose: true,
                    message: '傳票狀態變更已儲存',
                    type: 'success',
                });
            });
        },
        getCurrencyName(code) {
            if (this.currencyList.length > 0) {
                return this.currencyList.find((x) => x.cny === code).cnynam;
            }

            return '';
        },
        addVoucherAccount(index) {
            this.vouchers[index].accountItems.push({
                sno: null,
                vocherSno: 0, // 待補
                vono: null,
                accno: null,
                accnonam: null,
                content: null,
                crD_NTD: null,
                deB_NTD: null,
            });
        },
        addVoucher() {
            this.editIndex = this.vouchers.length;
            this.vouchers.push({
                sno: null,
                mno: null,
                vono: null,
                unT_NBR: this.$route.params.UNT_NBR,
                dat: null,
                mem: null,
                cny: null,
                voucherType: this.voucherType,
                unt: null,
                cnl: false,
                accountItems: [
                    {
                        sno: null,
                        vocherSno: null, // 待補
                        vono: null,
                        accno: null,
                        accnonam: null,
                        content: null,
                        crD_NTD: null,
                        deB_NTD: null,
                    },
                ],
            });
        },
        deleteVoucher(index) {
            this.vouchers.splice(index, 1);
        },
        getVoucherCRDAmount(index) {
            if (this.vouchers[index].accountItems) {
                return this.vouchers[index].accountItems.reduce((accumulator, currentValue) => accumulator + currentValue.crD_NTD, 0);
            }

            return 0;
        },
        getVoucherDEBAmount(index) {
            if (this.vouchers[index].accountItems) {
                return this.vouchers[index].accountItems.reduce((accumulator, currentValue) => accumulator + currentValue.deB_NTD, 0);
            }

            return 0;
        },
        getAccountingItem(item) {
            if (item.accno) {
                return `${item.accno} ${item.accnonam}`;
            }
            return '';
        },
        deleteSubItem(target, index) {
            target.splice(index, 1);
        },
        cancelEdit() {
            this.editIndex = null;
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.voucher-sheet {
    margin: 0 25px;
    font-size: 11pt;

    .creator-info {
        display: block;
        text-align: right;
        color: #666;
        font-size: 10pt;
        margin: 10px 0;
    }

    .actions {
        text-align: right;
        margin: 20px 0;
    }
}

.voucher-table {
    $border-color: #ccc;

    margin: 20px 0 0 0;
    width: 100%;
    border-top: 1px solid $border-color;
    border-left: 1px solid $border-color;
    border-right: 1px solid $border-color;

    th,
    td {
        border-bottom: 1px solid $border-color;
        padding: 5px 12px;

        &.setting {
            border-right: 1px solid $border-color;
        }

        &.name {
            border-right: 1px solid $border-color;
        }

        &.sum-label {
            border-right: 1px solid $border-color;
        }

        &.crd-amt {
            border-right: 1px solid $border-color;
        }
    }
}
</style>
